import React, { createContext, useContext, useEffect, useState, type JSX } from 'react';
import type { User as FirebaseUser } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config';

export type TUser = FirebaseUser | null;

interface IUserProviderProps {
  children: React.ReactNode;
}

interface IUserContextValue {
  user: TUser;
  isLoading: boolean;
}

const UserContext = createContext<IUserContextValue>({ user: null, isLoading: true });

export function UserProvider({ children }: Readonly<IUserProviderProps>): JSX.Element {
  const [user, setUser] = useState<TUser>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setIsLoading(false);
    });
    return (): void => unsubscribe();
  }, []);

  return <UserContext.Provider value={{ user, isLoading }}>{children}</UserContext.Provider>;
}

export function useUser(): IUserContextValue {
  return useContext(UserContext);
}

export { UserContext };
